import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AgGridReact } from "ag-grid-react";

import { Button, Form, Card, Spinner } from 'react-bootstrap';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';
import { FaEye, FaMinus } from 'react-icons/fa';
import PMRService from "../../../services/pmrservice";
import { CTSearchView, AccessGridTable, GiveUpAccessModal, StethoscopeLoading } from '../../../components';
import { useSelector, useDispatch } from "react-redux";
import { InternalSharedReportSave, InternalSharedReportAccessCheck, InternalSharedReportOneTimeAccessCheck } from 'apiServices/reducer/apiService';
import {
    IinternalSharedReportsFromOthers,
    InternalSharedReportsToOthers,
    InternalSharedReportsFromOthersComplete,
    ReportCategoriesGet,
    SharedReportValidityGet,
    getMRSitesReports,
    sharedReportGeneratecodeGet,
    shareReportQRCodeURL,
    sharedReportsValidCodesGet,
    mrSitesReportsGetByReportID,
    familyMembersUsersGet,
    internalSharedReportRevoke
} from 'apiServices';
import { getAllMRSItesReports } from 'apiServices/reducer/apiService';
import { FiActivity } from "react-icons/fi";
import { TbListDetails } from "react-icons/tb";

import downarrow from '../../../assets/images/logo/chevron_down.png';
import { set } from 'react-hook-form';
import { FaPowerOff } from 'react-icons/fa'; // FontAwesome icon
import Modal from "react-bootstrap/Modal";
import { useForm } from 'react-hook-form'; // Assuming you're using react-hook-form for form handling
import { Typeahead } from 'react-bootstrap-typeahead'; // Assuming you're using react-bootstrap-typeahead for typeahead functionality
import { FaFileAlt, FaUserSlash, FaHeartbeat, FaCheck, FaBeer, FaUndoAlt, FaExpandArrowsAlt, FaCompressArrowsAlt } from 'react-icons/fa';
import { BiUserMinus, BiUserCheck } from "react-icons/bi";
import { TbActivityHeartbeat } from "react-icons/tb";
import ReportDisplaySection from '../../../components/ReportDisplaySection';
import PatientSummarySection from '../../../components/PatientSummarySection';
import { useNavigate } from 'react-router-dom';
import { ViewReports } from '../../../components';
import './sharedReports.css'; // Add this import at the top for custom styles
import { PropaneSharp } from '@mui/icons-material';
import { toast } from 'react-toastify';
import debounce from "lodash.debounce";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import CustomSuccessModal from '../../../components/CustomSuccessModal';
import CustomAlertModal from '../../../components/CustomAlertModal';
import ReportPreview from "../../../components/previewControls";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import NotificationActionApproveReject from '../../../components/NotificationActionApproveReject';
import { filter } from 'lodash';
import { showPmrSuccess, showPmrError } from '../../../utils/swalUtils';
import AddNoteDialog from '../../dialogs/addNote/addNote';
import mammoth from 'mammoth';
import { getPdfViewerSrc, isDocxContentType, isDocxFileName, isOneTimeAccessValidUpTo } from '../../../utils/utils';

const customSuccessSVG = `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="white" stroke="#e6f4ea" stroke-width="2" />
    <path d="M18 28L25 35L38 22" stroke="#34a853" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const customErrorSVG = `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="white" stroke="#ffe6e6" stroke-width="2" />
    <path d="M18 18L38 38M38 18L18 38" stroke="var(--pmr-danger)" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const customWarningSVG = `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="white" stroke="#fff7e6" stroke-width="2" />
    <path d="M28 16v16M28 40h.01" stroke="#ffc107" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const ReportFileBody = ({ pdfUrl, fileName, contentType, validUpTo, className, style, title = 'Report Preview' }) => {
    const isDocx = isDocxContentType(contentType) || isDocxFileName(fileName);
    const [docxHtml, setDocxHtml] = useState('');
    const [docxError, setDocxError] = useState(null);
    const [docxLoading, setDocxLoading] = useState(false);

    useEffect(() => {
        if (!pdfUrl || !isDocx) {
            setDocxHtml('');
            setDocxError(null);
            setDocxLoading(false);
            return undefined;
        }

        let isMounted = true;
        setDocxHtml('');
        setDocxError(null);
        setDocxLoading(true);

        fetch(pdfUrl)
            .then((response) => response.arrayBuffer())
            .then((arrayBuffer) => mammoth.convertToHtml({ arrayBuffer }))
            .then((result) => {
                if (isMounted) {
                    setDocxHtml(result.value || '<p>No preview content available.</p>');
                }
            })
            .catch((error) => {
                console.error('Error rendering DOCX preview:', error);
                if (isMounted) {
                    setDocxError('Unable to preview this DOCX file.');
                }
            })
            .finally(() => {
                if (isMounted) setDocxLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, [pdfUrl, isDocx]);

    if (!pdfUrl) return null;

    if (isDocx) {
        if (docxLoading) {
            return <StethoscopeLoading className="flex-grow-1" />;
        }
        if (docxError) {
            return (
                <div className="d-flex align-items-center justify-content-center h-100">
                    <p className="text-danger fw-bold mb-0">{docxError}</p>
                </div>
            );
        }
        return (
            <div
                className={`bg-white ${className || ''}`}
                style={{
                    ...style,
                    overflow: 'auto',
                    padding: '16px 20px',
                }}
                dangerouslySetInnerHTML={{ __html: docxHtml }}
            />
        );
    }

    return (
        <iframe
            key={pdfUrl}
            src={getPdfViewerSrc(pdfUrl, validUpTo)}
            className={className}
            width="100%"
            height="95%"
            style={style}
            title={title}
        />
    );
};

// Add this component at the top level, before the SharedReports component
const PDFPreviewPanel = React.forwardRef(({ pdfUrl, selectedReportName, contentType, notes, validUpTo, onFullScreenToggle, isFullscreen, onClear, onNotesClick, isLoading = false }, ref) => {
    if (!pdfUrl && !isLoading) return null;
    return (
        <div
            ref={ref}
            className="col-md-12 d-flex flex-column border rounded shadow-lg bg-white pdf-preview-container"
            style={{ padding: "16px 24px 20px 24px", margin: "0", minHeight: 'calc(100vh - 165px)' }}
        >
            <div className="d-flex justify-content-between align-items-start mb-3">
                <div className="d-flex align-items-center">
                    <span>
                        Preview of <span style={{ color: "var(--pmr-secondary)" }}>{selectedReportName}</span>
                    </span>
                    <span
                        className="ms-2"
                        style={{ cursor: 'pointer' }}
                        onClick={onNotesClick}
                        title="Add Notes"
                    >
                        <FaFileAlt className="font-medium-3 text-warning" />
                    </span>
                </div>

                <div className="d-flex align-items-center gap-2">
                    {!isFullscreen && (
                        <span onClick={onClear} style={{ cursor: 'pointer', color: 'red' }}>
                            Clear
                        </span>
                    )}
                    {/* <OverlayTrigger
                        placement="top"
                        // overlay={<Tooltip id="fullscreen-tooltip">{isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}</Tooltip>}
                    > */}
                    <span onClick={onFullScreenToggle} className="fullscreen-icon" style={{ cursor: 'pointer' }}
                        title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                    >
                        {isFullscreen ? (
                            <FaCompressArrowsAlt
                                style={{ color: 'var(--pmr-text-muted)', fontSize: '18px' }}
                            />
                        ) : (
                            <FaExpandArrowsAlt
                                style={{ color: 'var(--pmr-text-muted)', fontSize: '18px' }}
                            />
                        )}
                    </span>
                    {/* </OverlayTrigger> */}
                </div>
            </div>

            <div style={{ color: "var(--pmr-secondary)", fontWeight: 1000 }} className="mb-2">
                Notes: <span style={{ color: "#222" }}>{notes || "NA"}</span>
            </div>

            {isLoading ? (
                <StethoscopeLoading className="flex-grow-1" />
            ) : (
                <ReportFileBody
                    pdfUrl={pdfUrl}
                    fileName={selectedReportName}
                    contentType={contentType}
                    validUpTo={validUpTo}
                    style={{
                        flex: 1,
                        border: "none",
                        minWidth: "100%",
                    }}
                    title="Report Preview"
                />
            )}
        </div>
    );
});

PDFPreviewPanel.displayName = 'PDFPreviewPanel';

const SharedReports = (props) => {
    const dispatch = useDispatch();
    const [showNotesDialog, setShowNotesDialog] = useState(false);
    const [selectedReportForNotes, setSelectedReportForNotes] = useState(null);
    const userData = useSelector((state) => state.apiService.login);
    const token = userData?.Token || '';
    const navigate = useNavigate();

    // Use selectedFamilyMember's user_id if available, otherwise use current user's user_id
    const selectedFamilyMember = props.selectedFamilyMember;
    const userId = selectedFamilyMember?.user_id || userData.user_id;
    const useTtabs = ['With You', 'By You', 'Approve Access', 'Share Everywhere'];
    const providerTabs = ['With You', 'Request Access'];

    const tabs = (userData?.user_type_name === 'Provider') ? providerTabs : useTtabs;
    const isProvider = userData?.user_type_name === 'Provider';


    const [searchQuery, setSearchQuery] = useState('');
    const [patientSummaryData, setPatientSummaryData] = useState({});
    const [showTabs, setShowTabs] = useState(true);
    const [isProviderReports, setIsProviderReports] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const previewContainerRef = useRef(null);

    // Use activeTab and setActiveTab from props if provided, otherwise use internal state
    const [internalActiveTab, setInternalActiveTab] = useState('With You'); // Default to 'With You'
    const [activeTab, setActiveTab] = useState(props.activeSharedTab !== undefined ? props.activeSharedTab : internalActiveTab);
    //const setActiveTab = props.setActiveTab !== undefined ? props.setActiveTab : setInternalActiveTab;

    // Update internalActiveTab when isProvider changes
    useEffect(() => {
        // console.log("Updating internalActiveTab, isProvider:", isProvider);
        setInternalActiveTab(isProvider ? 'Request Access' : 'With You');
    }, [isProvider]);

    // Update activeTab when props.activeSharedTab changes
    useEffect(() => {
        // console.log('SharedReports: props.activeSharedTab changed to:', props.activeSharedTab);
        if (props.activeSharedTab !== undefined) {
            setActiveTab(props.activeSharedTab);
        }
    }, [props.activeSharedTab]);

    // Update activeTab when internalActiveTab changes (but only if no props.activeSharedTab is provided)
    useEffect(() => {
        // console.log('SharedReports: internalActiveTab changed to:', internalActiveTab);
        if (props.activeSharedTab === undefined) {
            setActiveTab(internalActiveTab);
        }
    }, [internalActiveTab, props.activeSharedTab]);

    const [loading, setLoading] = useState(false);
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false);
    const [sharedReportsData, setSharedReportsData] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [pdfUrl, setPDFURL] = useState(null);
    const [previewContentType, setPreviewContentType] = useState('');
    const [selectedReports, setSelectedReports] = useState([]);
    const [validityOptions, setValidityOptions] = useState([]);
    const [selectedValidity, setSelectedValidity] = useState('');
    const [openDropdowns, setOpenDropdowns] = useState([]);
    const [subItemsMap, setSubItemsMap] = useState([]);
    const [showQRCode, setShowQRCode] = useState(false);
    const [error, setError] = useState(false);
    const [shareName, setShareName] = useState('');
    const [isInvalid, setIsInvalid] = useState(false);
    const [generatedCode, setGeneratedCode] = useState('');
    const [codeGenerated, setCodeGenerated] = useState('');
    const [expirationMessage, setExpirationMessage] = useState('');
    const [everywhereshareId, setEverywhereshareId] = useState('');
    const [shareCode, setShareCode] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [qrCodeUrl, setQRCodeUrl] = useState('');
    const [showActiveCodes, setShowActiveCodes] = useState(false);
    const showActiveCodesRef = useRef(false);
    const [checkboxesDisabled, setCheckboxesDisabled] = useState(false);
    const [showPDF, setShowPDF] = useState(false);
    const [qrCodeUrls, setQRCodeUrls] = useState({});
    const canvasRef = useRef(null);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [submitClicked, setSubmitClicked] = useState(false);
    const [patientName, setPatientName] = useState('');
    const [selectedSubItems, setSelectedSubItems] = useState([]);
    const [showGiveUpModal, setShowGiveUpModal] = useState(false);
    const [giveUpRowData, setGiveUpRowData] = useState(null);
    const [revokedShareIds, setRevokedShareIds] = useState(new Set());
    const [isRevokeAction, setIsRevokeAction] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [familyResults, setFamilyResults] = useState([]);
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [requestModalMessage, setRequestModalMessage] = useState('');
    const [requestModalType, setRequestModalType] = useState('success'); // or 'alert'
    const [showPatientSummaryModal, setShowPatientSummaryModal] = useState(false);
    const typeaheadRef = useRef(null);
    const [selectionError, setSelectionError] = useState(false);
    const [categoryId, setCategoryId] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [message, setMessage] = useState('');
    const [isCategoryInvalid, setIsCategoryInvalid] = useState(false);
    const [isNameInvalid, setIsNameInvalid] = useState(false);
    const [isUserSelectionInvalid, setIsUserSelectionInvalid] = useState(false);
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);

    // Notes dialog handlers
    const handleNotesClick = () => {
        // Check if we have the required data to open notes dialog
        if (!selectedReportForNotes || !selectedReportForNotes.report_id) {
            console.error("No report selected for notes. Please click on a report first.");
            return;
        }

        setShowNotesDialog(true);
    }

    const handleNotesSave = (newNote) => {
    }

    const handleNotesClose = () => {
        setShowNotesDialog(false);
        // Don't reset selectedReportForNotes - keep it for future use
        // setSelectedReportForNotes(null);
    }
    const containerRef = useRef(null);
    const [height, setHeight] = useState('80vh'); // fallback default

    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                const containerHeight = containerRef.current.offsetHeight;
                const viewportHeight = window.innerHeight;
                const zoomLevel = window.devicePixelRatio || 1;

                // Adjust calculation based on zoom level
                let heightMultiplier = 0.5;
                let viewportMultiplier = 0.7;

                if (zoomLevel >= 1.5) {
                    // At 150% zoom or higher, be more conservative
                    heightMultiplier = 0.4;
                    viewportMultiplier = 0.6;
                } else if (zoomLevel >= 1.25) {
                    // At 125% zoom, slightly more conservative
                    heightMultiplier = 0.45;
                    viewportMultiplier = 0.65;
                }

                const calculatedHeight = Math.min(containerHeight * heightMultiplier, viewportHeight * viewportMultiplier);
                console.log("calculatedHeight", calculatedHeight)
                setHeight(calculatedHeight);
            }
        };

        const observer = new ResizeObserver(updateHeight);

        if (containerRef.current) {
            observer.observe(containerRef.current);
            updateHeight(); // Initial calculation
        }

        // Listen for zoom changes
        window.addEventListener('resize', updateHeight);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    useEffect(() => {
        console.log('Updated height:', height);
    }, [height]);

    // Fix body overflow at high zoom levels
    useEffect(() => {
        const fixBodyOverflow = () => {
            const zoomLevel = window.devicePixelRatio || 1;
            if (zoomLevel >= 1.5) {
                // At 150% zoom or higher, prevent body overflow
                document.body.style.overflowX = 'hidden';
                document.body.style.overflowY = 'auto';
            } else {
                // Reset to default at normal zoom levels
                document.body.style.overflowX = '';
                document.body.style.overflowY = '';
            }
            console.log("zoomLevel", zoomLevel)

        };
        fixBodyOverflow();
        window.addEventListener('resize', fixBodyOverflow);

        return () => {
            window.removeEventListener('resize', fixBodyOverflow);
            // Reset body styles on cleanup
            document.body.style.overflowX = '';
            document.body.style.overflowY = '';
        };
    }, []);
    const fetchRequestAccessData = useCallback(() => {
        setLoading(true);
        const params = { token, user_id: userId };
        dispatch(InternalSharedReportsFromOthersComplete(params))
            .then((response) => {
                const tableData = response.payload.Table || [];
                const combinedData = tableData
                    .filter(report => !revokedShareIds.has(report.share_id))
                    .map((report) => ({
                        requestedTo: report.shared_by,
                        requestedOn: report.shared_on,
                        approved: report.approved_yn,
                        approvedOn: report.approved_on,
                        shared_from_id: report.shared_from_id,
                        sharedBy: report.shared_by,
                        share_id: report.share_id
                    }));
                setLstReportsFromOthersComplete(combinedData);
                console.log("combinedData", combinedData);
            })
            .catch((error) => {
                console.error("Error fetching shared reports:", error);
                setError(true);
            })
            .finally(() => setLoading(false));
    }, [dispatch, userId, token, revokedShareIds]);



    const [lstReportsFromOthersComplete, setLstReportsFromOthersComplete] = useState([
        {
            requestedTo: 'TESTUSER 0456',
            requestedOn: '05/05/2025 13:47',
            approved: true,
            approvedOn: '05/05/2025 13:47',
        }
    ]);
    const clearPdfPreview = useCallback(() => {
        setPDFURL((prev) => {
            if (prev) URL.revokeObjectURL(prev);
            return null;
        });
        setShowPDF(false);
        setPreviewContentType('');
        setIsReportPreviewLoading(false);
        setSelectedReportName('');
        setSelectedRow(null);
        setSelectedRowIndex(null);
        setSelectedRowData(null);
        setSelectedReportForNotes(null);
        const previewIframe = document.querySelector('iframe[title="Report Preview"]');
        if (previewIframe) previewIframe.src = '';
    }, []);

    const onClear = () => {
        setSearchQuery('');
        clearPdfPreview();
    };
    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: '',
        ProviderName: '',
        HospitalName: '',
        UserID: 0,
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: token
    });
    const [selectedUserId, setSelectedUserId] = useState();
    const [showReportDisplayModal, setShowReportDisplayModal] = useState(false);
    const [reportDisplayData, setReportDisplayData] = useState({ pdfUrl: null, reportName: '' });
    const [selectedReportName, setSelectedReportName] = useState('');

    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [approvalRowData, setApprovalRowData] = useState(null);

    const handleReportIconClick = (shared_from_id, requestedTo) => {
        props.handleReportIconClick(shared_from_id, requestedTo);
        localStorage.setItem('patientUserId', shared_from_id);
        localStorage.setItem('patientUserName', requestedTo);
    }
    const handlePatientSummary = (shared_from_id, requestedTo) => {
        props.handlePatientSummaryClick(shared_from_id, requestedTo);
        localStorage.setItem('patientUserId', shared_from_id);
        localStorage.setItem('patientUserName', requestedTo);
    }
    // const handlePatientSummary = (shared_from_id, requestedTo) => {
    //     // Store patient info in localStorage
    //     localStorage.setItem('patientUserId', shared_from_id);
    //     localStorage.setItem('patientUserName', requestedTo);

    //     // Navigate to PatientSummarySection page
    //     navigate('/patient-summary');

    //     // Also call the parent handler if it exists (for backward compatibility)
    //     if (props.handlePatientSummaryClick) {
    //         props.handlePatientSummaryClick(shared_from_id, requestedTo);
    //     }
    // }

    const handleApproveAccess = (rowData) => {

        // Check if already approved or rejected - don't show popup
        if (rowData.approved === true || rowData.approved === false) {
            return;
        }

        // Map the row data to the format expected by NotificationActionApproveReject
        const mappedRowData = {
            share_id: rowData.share_id,
            shared_to_name: rowData.shared_to_user || rowData.sharedBy,
            shared_from_id: rowData.shared_from_id,
            approved_yn: null, // Set to null to show approve/reject buttons
            notes: rowData.notes || '',
            comments: rowData.comments || ''
        };

        setApprovalRowData(mappedRowData);
        setShowApprovalModal(true);
    };

    const handleTabClick = (tab) => {
        // Only reset states if switching to a different tab
        if (activeTab !== tab) {
            // Reset all states only when switching tabs
            setActiveTab(tab);
            setLoading(false);
            setSharedReportsData([]);
            setSelectedReport(null);
            setPDFURL(null);
            setSelectedReports([]);
            setValidityOptions([]);
            setSelectedValidity('');
            setOpenDropdowns([]);
            setSubItemsMap([]);
            setShowQRCode(false);
            setError(false);
            setShareName('');
            // setIsInvalid(false);
            setIsCategoryInvalid(false);
            setIsNameInvalid(false);
            setIsUserSelectionInvalid(false);
            setGeneratedCode('');
            setCodeGenerated('');
            setExpirationMessage('');
            setEverywhereshareId('');
            setExpiryDate('');
            setQRCodeUrl('');
            setShowActiveCodes(false);
            setCheckboxesDisabled(false);
            setShowPDF(false);
            setIsReportPreviewLoading(false);
            setSelectedRow(null); // Reset selected row when switching tabs
            setSelectedRowIndex(null); // Reset selected row index
            setSelectedRowData(null); // Reset selected row data

            // Clear any existing timeouts or intervals if you have any
            if (canvasRef.current) {
                const canvas = canvasRef.current;
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }

            // Reset form if it exists
            const form = document.querySelector('form');
            if (form) {
                form.reset();
            }

            // Clear any existing PDF preview
            const iframe = document.querySelector('iframe');
            if (iframe) {
                iframe.src = '';
            }

            // Release any existing blob URLs to prevent memory leaks
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        } else {
            // If clicking the same tab, just update the active tab state
            setActiveTab(tab);
        }
    };

    const handlePatientUserId = (event) => {
    }


    const IconCellRenderer = (props) => {
        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <FaBeer style={{ marginRight: '5px' }} />
                {props.value}
            </span>
        );
    };

    const columnDefs = [
        {
            headerName: 'Give up access',
            field: 'giveUp',
            colId: 'giveUp',
            filter: false,
            width: 150,
            sortable: false,
            tooltipField: 'giveUp',
            headerTooltip: 'Give up access',
            cellRenderer: (params) => (
                <div
                    className="give-up-access-cell"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!params.data?.share_id) {
                            return;
                        }
                        setGiveUpRowData(params.data);
                        setShowGiveUpModal(true);
                    }}
                    style={{ cursor: 'pointer', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <BiUserMinus
                        size={25}
                        color="red"
                    />
                </div>
            ),
            headerClass: 'ag-center-header',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' },
        },
        {
            headerName: 'Reports',
            field: 'reports', filter: false,
            width: 130,
            sortable: false,
            tooltipField: 'reports',
            headerTooltip: 'Reports',
            cellRenderer: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    {params.data.approved
                        ? <FaFileAlt
                            className="mx-auto"
                            size={20}
                            color="green"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                handleReportIconClick(params.data.shared_from_id, params.data.requestedTo)
                            }
                        />
                        : null}
                </div>
            ),
            headerClass: 'ag-center-header',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' },
        },
        {
            headerName: 'Details',
            field: 'details',
            width: 130,
            filter: false,
            sortable: false,
            tooltipField: 'details',
            headerTooltip: 'Details',
            cellRenderer: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    {params.data.approved
                        ? <TbListDetails
                            className="mx-auto"
                            size={20}
                            color="var(--pmr-secondary)"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                handlePatientSummary(params.data.shared_from_id, params.data.requestedTo)
                            }
                        />
                        : null}
                </div>
            ),
            headerClass: 'ag-center-header',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' },
        },
        {
            headerName: 'Requested to',
            field: 'requestedTo',
            flex: 1,
            headerClass: 'ag-center-header-text-color',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', alignItems: 'center', textAlign: 'center' },
            sortable: true,
            filter: true,
            tooltipField: 'requestedTo',
            headerTooltip: 'Requested to',
        },
        {
            headerName: 'Requested on',
            field: 'requestedOn',
            width: 200,
            headerClass: 'ag-center-header-text-color',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', alignItems: 'center', textAlign: 'center' },
            tooltipField: 'requestedOn',
            headerTooltip: 'Requested on',
        },
        {
            headerName: 'Approved',
            field: 'approved',
            width: 160,
            filter: false,
            sortable: false,
            headerTooltip: 'Approved',
            cellRenderer: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    {params.value ? <FaCheck className="mx-auto" size={20} color="green" /> : null}
                </div>
            ),
            headerClass: 'ag-center-header',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' },
        },
        {
            headerName: 'Approved on',
            field: 'approvedOn',
            width: 200,
            tooltipField: 'approvedOn',
            headerTooltip: 'Approved on',
            headerClass: 'ag-center-header-text-color',
            cellStyle: { color: 'black', fontWeight: 'bold', display: 'flex', alignItems: 'center', textAlign: 'center' },
        },
    ];


    const [rowData, setRowData] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);


    const withYouColumns = [
        {
            headerName: 'Report Name', field: 'reportName', flex: 2, cellClass: 'griddata-label', tooltipField: 'reportName',
            headerTooltip: 'Report Name',
            cellRenderer: (params) => {
                const name = params.data?.reportName;

                return (
                    <div
                        className="text-decoration-underline text-black"
                        title={name}  // Tooltip for link
                    >
                        {name}
                    </div>
                )
            },
        },
        {
            headerName: 'Shared By', field: 'sharedBy', flex: 1, cellClass: 'griddata-label', tooltipField: 'sharedBy',
            headerTooltip: 'Shared By'
        },
        {
            headerName: 'Shared On', field: 'sharedOn', flex: 1, cellClass: 'griddata-label', tooltipField: 'sharedOn',
            headerTooltip: 'Shared On'
        },
        {
            headerName: 'Valid Upto', field: 'validUpTo', flex: 1, cellClass: 'griddata-label', tooltipField: 'validUpTo',
            headerTooltip: 'Valid Upto'
        },
        {
            headerName: 'Give up Access',
            field: 'giveUpAccess',
            colId: 'giveUpAccess',
            flex: 1,
            tooltipField: 'giveUpAccess',
            headerTooltip: 'Give up Access',
            headerClass: 'ag-center-header',
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
            filter: false,
            sortable: false,
            cellRenderer: (params) => (
                <div
                    className="give-up-access-cell"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!params.data?.share_id) {
                            return;
                        }
                        setGiveUpRowData(params.data);
                        setShowGiveUpModal(true);
                    }}
                    style={{ cursor: 'pointer', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <BiUserMinus
                        size={25}
                        color="red"
                    />
                </div>
            )
        }
    ];


    const handleRevokeAccess = (rowData) => {
        if (!rowData?.share_id) {
            return;
        }

        setIsRevokeAction(true);
        setGiveUpRowData(rowData);
        setShowGiveUpModal(true);
    };

    const byYouColumns = [
        {
            headerName: 'Report Name', field: 'reportName', flex: showPDF ? 0.8 : 2, cellClass: 'griddata-label', tooltipField: 'reportName',
            headerTooltip: 'Report Name',
            cellRenderer: (params) => {
                const name = params.data?.reportName;

                return (
                    <div
                        className="text-decoration-underline text-black"
                        title={name}  // Tooltip for link
                    >
                        {name}
                    </div>
                )
            },
        },
        {
            headerName: 'Shared To', field: 'sharedBy', flex: showPDF ? 0.8 : 1, cellClass: 'griddata-label', tooltipField: 'sharedBy',
            headerTooltip: 'Shared To'
        },
        {
            headerName: 'Shared On', field: 'sharedOn', flex: showPDF ? 0.7 : 1, cellClass: 'griddata-label', tooltipField: 'sharedOn',
            headerTooltip: 'Shared On'
        },
        {
            headerName: 'Valid Upto', field: 'validUpTo', flex: showPDF ? 0.7 : 1, cellClass: 'griddata-label', tooltipField: 'validUpTo',
            headerTooltip: 'Valid Upto'
        },
        // { headerName: 'Last Accessed On', flex: showPDF ? 0.7 : 1, cellClass: 'griddata-label' },
        {
            headerName: 'Revoke Access',
            field: 'revokeAccess',
            colId: 'revokeAccess',
            flex: 0.6,
            cellClass: 'p-1',
            sortable: false,
            headerTooltip: 'Revoke Access',
            cellRenderer: (params) => (
                <FaUndoAlt
                    className="text-danger-500 mx-auto"
                    size={15}
                    color="red"
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleRevokeAccess(params.data);
                    }}
                />
            ),
            filter: false
        }
    ];

    const approveAccessColumns = [
        {
            headerName: 'Give up Access',
            field: 'giveUpAccess',
            colId: 'giveUpAccess',
            flex: 0.6,
            filter: false,
            sortable: false,
            tooltipField: 'giveUpAccess',
            headerTooltip: 'Give up Access',
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
            cellRenderer: (params) => (
                <div
                    className="give-up-access-cell"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!params.data?.share_id) {
                            return;
                        }
                        setGiveUpRowData(params.data);
                        setShowGiveUpModal(true);
                    }}
                    style={{ cursor: 'pointer', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <BiUserMinus
                        size={25}
                        color="red"
                    />
                </div>
            )
        },
        {
            headerName: 'Requested From',
            field: 'shared_to_user',
            flex: 3,
            cellClass: 'griddata-label',
            tooltipField: 'shared_to_user',
            headerTooltip: 'Requested From',
        },
        {
            headerName: 'Requested On',
            field: 'sharedOn',
            flex: 0.8,
            cellClass: 'griddata-label',
            tooltipField: 'sharedOn',
            headerTooltip: 'Requested On',
        },
        {
            headerName: 'Approved On',
            field: 'validUpTo',
            flex: 0.8,
            cellClass: 'griddata-label',
            tooltipField: 'validUpTo',
            headerTooltip: 'Approved On',
        },
        {
            headerName: 'Action',
            flex: 0.8,
            filter: false,
            sortable: false,
            tooltipField: 'action',
            headerTooltip: 'Action',
            cellRenderer: (params) => {
                return (
                    <div className="d-flex justify-content-center gap-2">
                        {/* Show status based on approval state */}
                        {params.data.approved === true ? (
                            <span
                                style={{
                                    color: 'green',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                Approved
                            </span>
                        ) : params.data.approved === false ? (
                            <span
                                style={{
                                    color: 'red',
                                    fontWeight: 'bold',
                                    fontSize: '14px'
                                }}
                            >
                                Rejected
                            </span>
                        ) : (
                            /* Show approve icon only if not yet processed (null/undefined) */
                            <BiUserCheck
                                size={22}
                                color="green"
                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                title="Click to Approve or Reject"
                                onClick={() => handleApproveAccess(params.data)}
                            />
                        )}
                    </div>
                );
            }
        }
    ];

    // Effect to update checkboxes disabled state
    useEffect(() => {
        setCheckboxesDisabled(!!generatedCode);
    }, [generatedCode, isProvider]);

    //let newSelected = selectedReports.filter(reportId => reportId !== id);
    if (selectedReports.includes(0)) {
        // newSelected = newSelected.filter(reportId => reportId !== 0); // ❌ This is trying to reassign a `const`
    }

    // Handle checkbox changes
    const handleCheckboxChange = (id) => {

        //if (checkboxesDisabled) return;
        setCategoryId(id)

        if (id === 0) {
            if (selectedReports.includes(0)) {
                // Deselect all categories and all subitems
                setSelectedReports([]);
                setSelectedSubItems([]);

            } else {
                // Select all categories and all subitems
                const allIds = [0, ...sharedReportsData.filter(r => r.id !== 0).map(r => r.id)];
                setSelectedReports(allIds);

                // Also select all subitems
                const allSubItemIds = subItemsMap.map(subItem => subItem.groupid);
                setSelectedSubItems(allSubItemIds);
            }
        } else {
            if (selectedReports.includes(id)) {
                let newSelected = selectedReports.filter(reportId => reportId !== id);
                if (selectedReports.includes(0)) {
                    newSelected = newSelected.filter(reportId => reportId !== 0);
                }
                setSelectedReports(newSelected);

                // Also deselect subitems for this category
                const categoryName = sharedReportsData.find(r => r.id === id)?.Name;
                if (categoryName) {
                    const categorySubItems = subItemsMap
                        .filter(subItem => subItem.group === categoryName)
                        .map(subItem => subItem.groupid);
                    setSelectedSubItems(prev =>
                        prev.filter(subItemId => !categorySubItems.includes(subItemId))
                    );
                }
            } else {
                let newSelected = [...selectedReports, id];
                const allIndividualReports = sharedReportsData.filter(r => r.id !== 0).map(r => r.id);
                const allSelected = allIndividualReports.every(reportId => newSelected.includes(reportId));
                if (allSelected && !newSelected.includes(0)) {
                    newSelected.push(0);
                }
                setSelectedReports(newSelected);

                // Also select subitems for this category
                const categoryName = sharedReportsData.find(r => r.id === id)?.Name;
                if (categoryName) {
                    const categorySubItems = subItemsMap
                        .filter(subItem => subItem.group === categoryName)
                        .map(subItem => subItem.groupid);
                    setSelectedSubItems(prev =>
                        [...new Set([...prev, ...categorySubItems])]
                    );
                }
            }
        }
    };
    const checkOneTimeAccessAfterPreview = useCallback(async (rowData) => {
        if (!rowData?.share_id) {
            return false;
        }

        try {
            const checkResp = await dispatch(
                InternalSharedReportOneTimeAccessCheck({
                    loginUserId: userId,
                    shareId: rowData.share_id,
                    validUpto: rowData.validUpTo,
                    token,
                })
            ).unwrap();
            console.log("checkResp", checkResp);
            if (checkResp === true) {
                return true;
            }

            clearPdfPreview();
            showPmrError({
                title: 'Access Unavailable',
                message: 'This one-time access report has already been viewed.',
            });
            return false;
        } catch (error) {
            console.error('InternalSharedReportOneTimeAccessCheck failed:', error);
            clearPdfPreview();
            showPmrError({
                title: 'Error',
                message: 'Unable to verify one-time access. Please try again.',
            });
            return false;
        }
    }, [dispatch, userId, token, clearPdfPreview]);

    // Handle report click and PDF preview
    const handleReportClick = (event) => {
        // Check if the click target is within the "Give Up Access" column
        const clickedElement = event.event?.target;
        if (clickedElement) {
            // Check if the clicked element or its parent is within the give up access cell
            const isGiveUpAccessClick = clickedElement.closest('.give-up-access-cell') ||
                clickedElement.closest('[col-id="giveUpAccess"]') ||
                clickedElement.closest('[col-id="giveUp"]') ||
                clickedElement.closest('.ag-cell[col-id="giveUpAccess"]') ||
                clickedElement.closest('.ag-cell[col-id="giveUp"]') ||
                clickedElement.classList.contains('give-up-access-cell') ||
                clickedElement.closest('.bi-user-minus');

            // Check if the click is on the Revoke Access column
            const isRevokeAccessClick = clickedElement.closest('[col-id="revokeAccess"]') ||
                clickedElement.closest('.ag-cell[col-id="revokeAccess"]') ||
                clickedElement.closest('.fa-undo-alt') ||
                clickedElement.classList.contains('fa-undo-alt');

            // Check if the click is on the Approve Action column
            const isApproveActionClick = clickedElement.closest('.bi-user-check') ||
                clickedElement.classList.contains('bi-user-check');

            if (isGiveUpAccessClick || isRevokeAccessClick || isApproveActionClick) {
                return;
            }
        }

        const reportId = event.data?.reportID;
        setSelectedRowIndex(event.rowIndex);
        setSelectedRowData(event.data);
        setSelectedRow(event.rowIndex); // Set selected row for styling 

        if (!reportId) {
            console.error("No valid report ID found in row data:", event.data);
            return;
        }

        // Set the selected report for notes immediately
        setSelectedReportForNotes({
            report_id: reportId,
            report_name: event.data.reportName,
            original_user_id: event.data.shared_from_id || event.data.shared_by_user_id || null
        });

        const params = {
            ReportID: reportId,
            UserID: userId,
            token: token
        }
        setIsReportPreviewLoading(true);
        setPDFURL(null);
        setPreviewContentType('');
        setShowPDF(true);
        PMRService.getPMRReportsPerId(params)
            .then((resp) => {
                const blobUrl = URL.createObjectURL(resp);
                setPreviewContentType(resp?.type || '');
                setPDFURL(blobUrl);
                setSelectedReportName(event.data.reportName);
                setShowPDF(true);

                if (activeTab === "With You") {
                    checkOneTimeAccessAfterPreview(event.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching PDF:", error);
                setError(true);
            })
            .finally(() => setIsReportPreviewLoading(false));
    };

    // Toggle dropdown
    const toggleDropdown = (id) => {
        setOpenDropdowns(prev => {
            if (prev.includes(id)) {
                // If dropdown is open, close it
                return prev.filter(dropdownId => dropdownId !== id);
            } else {
                // If dropdown is closed, open it
                return [...prev, id];
            }
        });
    };

    // Handle eye click for preview

    const [selectedGroupName, setSelectedGroupName] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleEyeClick = async (groupName, groupid) => {
        const params = {
            UserID: userId,
            ReportID: groupid,
            token: token
        };
        setSelectedGroupName(groupName);
        setShowModal(true);
        setIsReportPreviewLoading(true);
        setPDFURL(null);
        setPreviewContentType('');
        dispatch(mrSitesReportsGetByReportID(params))
            .then((response) => {
                const resp = response.payload;
                const blobUrl = URL.createObjectURL(resp);
                setPreviewContentType(resp?.type || '');
                setPDFURL(blobUrl);
            })
            .catch((error) => {
                console.error("Error fetching shared reports:", error);
                setError(true);
            })
            .finally(() => setIsReportPreviewLoading(false));


    }

    // Generate code
    const handleGenerateCode = () => {
        setIsCategoryInvalid(false);
        setIsNameInvalid(false);

        if (selectedReports.length === 0 && selectedSubItems.length === 0 && !shareName.trim()) {
            setIsCategoryInvalid(true);
            setIsNameInvalid(true);
            return;
        }

        if (selectedReports.length === 0 && selectedSubItems.length === 0) {
            setIsCategoryInvalid(true);
            // alert("Please select at least one report category or subitem");
            return;
        }
        if (!shareName.trim()) {
            setIsNameInvalid(true);
            return;
        }

        //  setIsInvalid(false);
        setLoading(true);

        const code = Math.random().toString(36).substring(2, 8).toUpperCase();
        setGeneratedCode(code);
        setShowQRCode(true);

        let categoryIdsStr = '';

        // Handle "Select All" case
        if (categoryId === 0 || selectedReports.includes(0)) {
            categoryIdsStr = '0';
        } else {
            // Build the CategoryID string in format: "categoryID-reportID1,reportID2; categoryID2-reportID3"
            const categoryReportMap = new Map();

            // Process selected subitems to group by category
            selectedSubItems.forEach(reportId => {
                const subItem = subItemsMap.find(item => item.groupid === reportId);
                if (subItem) {
                    const categoryName = subItem.group;
                    const category = sharedReportsData.find(cat => cat.Name === categoryName);
                    if (category) {
                        const categoryId = category.id;
                        if (!categoryReportMap.has(categoryId)) {
                            categoryReportMap.set(categoryId, []);
                        }
                        categoryReportMap.get(categoryId).push(reportId);
                    }
                }
            });

            // If categories are selected but no subitems, include all subitems for those categories
            selectedReports.filter(id => id !== 0).forEach(categoryId => {
                const category = sharedReportsData.find(cat => cat.id === categoryId);
                if (category) {
                    const categorySubItems = subItemsMap
                        .filter(item => item.group === category.Name)
                        .map(item => item.groupid);

                    if (!categoryReportMap.has(categoryId)) {
                        categoryReportMap.set(categoryId, []);
                    }

                    // Add any subitems that aren't already included
                    categorySubItems.forEach(reportId => {
                        if (!categoryReportMap.get(categoryId).includes(reportId)) {
                            categoryReportMap.get(categoryId).push(reportId);
                        }
                    });
                }
            });

            // Build the final string
            const categoryStrings = [];
            categoryReportMap.forEach((reportIds, categoryId) => {
                if (reportIds.length > 0) {
                    categoryStrings.push(`${categoryId}-${reportIds.join(',')}`);
                }
            });

            categoryIdsStr = categoryStrings.join('; ');
        }

        // const params = {
        //     user_id: userId,
        //     token: token,
        //     CategoryID: categoryIdsStr,
        //     DurationID: selectedValidity,
        //     ShareWithName: shareName,
        // };

        dispatch(sharedReportGeneratecodeGet({
            user_id: userId,
            CategoryID: categoryIdsStr,
            DurationID: selectedValidity,
            ShareWithName: shareName,
            token: token
        }))
            .then((response) => {
                const Table = response.payload?.Table || [];
                if (Table.length > 0) {
                    const report = Table[0];
                    const { GeneratedCode, ExpirationMessage, everywhereshare_id, ValidUpto, ValidUpTo } = report;
                    setCodeGenerated(GeneratedCode);
                    setExpirationMessage(ExpirationMessage);
                    setEverywhereshareId(everywhereshare_id);
                    setSelectedReports([]);
                    setSelectedSubItems([]);
                    setOpenDropdowns([]);
                    setCategoryId(null);
                    setIsCategoryInvalid(false);

                    // Set the expiry date if available in the response
                    if (ValidUpto || ValidUpTo) {
                        setExpiryDate(ValidUpto || ValidUpTo);
                    }
                    if (everywhereshare_id) {
                        const qrParams = {
                            shareId: everywhereshare_id,
                            token,
                            user_id: userId
                        };
                        setQRCodeUrl(null);
                        dispatch(shareReportQRCodeURL(qrParams))
                            .then((qrResponse) => {
                                const base64String = qrResponse.payload?.base64String;
                                if (base64String) {
                                    const qrUrl = `data:image/png;base64,${base64String}`;
                                    setQRCodeUrl(qrUrl);
                                    // After generating a code, always fetch active codes from API with a small delay
                                    // to ensure the database has been updated
                                    setTimeout(() => {
                                        fetchActiveCodesFromAPI({ syncToggle: true });
                                    }, 1000); // 1 second delay
                                } else {
                                    setError(true);
                                }
                            })
                            .catch(() => setError(true));
                    } else {
                        setError(true);
                    }
                    if (canvasRef.current) {
                        const canvas = canvasRef.current;
                        const ctx = canvas.getContext('2d');
                        canvas.style.border = '2px solid black';
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        ctx.fillStyle = "#fff";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.font = "bold 35px 'Segoe UI'";
                        ctx.fillStyle = '#000';
                        ctx.fillText(GeneratedCode, 24, 50);
                    }
                }
            })
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    };


    // Reset code generation
    const handleNewCode = () => {
        setGeneratedCode("");
        setCodeGenerated("");
        setExpirationMessage("");
        setShowQRCode(false);
        setShareName("");
        setQRCodeUrl('');
        setCheckboxesDisabled(false);
        setError(false);
        setSelectedReports([]);
        setSelectedSubItems([]);
        setOpenDropdowns([]);
        setCategoryId(null);
        // Reset validity to first option if available
        if (validityOptions.length > 0) {
            setSelectedValidity(validityOptions[0].id);
        }
    };

    const handleCancelCode = () => {
        handleNewCode();
    };

    // Fetch shared report validity options
    // const fetchSharedReportValidity = () => {
    //     const params = { token, user_id: userId };
    //     dispatch(SharedReportValidityGet(params))
    //         .then((response) => {
    //             const Table = response.payload.Table;
    //             const combinedData = Table.map((report) => ({
    //                 Duration: report.duration,
    //                 id: report.id,
    //             }));
    //             setValidityOptions(combinedData);
    //             // Set the first option as default selected
    //             if (combinedData.length > 0) {
    //                 setSelectedValidity(combinedData[0].id);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("Error fetching validity options:", error);
    //             setError(true);
    //         });
    // };

    // Clear validation error when loading changes for Request Access tab
    useEffect(() => {
        if (activeTab === "Request Access" && loading) {
            setIsUserSelectionInvalid(false);
        }
    }, [loading, activeTab]);

    // Fetch data based on active tab
    useEffect(() => {
        const params = { token, user_id: userId };
        if (activeTab === "With You") {
            setLoading(true);
            dispatch(IinternalSharedReportsFromOthers(params))
                .then((response) => {
                    const { Table, Table1 } = response.payload;
                    const combinedData = Table1.map((report, index) => {
                        const mappedData = {
                            sharedBy: report.shared_by,
                            relationType: report.relation_type,
                            reportName: Table1[index]?.report_name,
                            sharedOn: Table1[index]?.shared_on,
                            validUpTo: Table1[index]?.valid_up_to,
                            reportID: Table1[index]?.report_id,
                            share_id: Table1[index]?.share_id, // Make sure this is included
                            shared_from_id: report.shared_from_id || report.shared_by_user_id || null, // Add original user ID
                            notes: Table1[index]?.notes || "NA"
                        };
                        return mappedData;
                    });
                    setSharedReportsData(combinedData);
                })
                .catch((error) => {
                    console.error("Error fetching shared reports:", error);
                    setError(true);
                })
                .finally(() => setLoading(false));
        }
        else if (activeTab === "By You") {
            setLoading(true);
            dispatch(InternalSharedReportsToOthers(params))
                .then((response) => {
                    const { Table, Table1 } = response.payload;
                    const combinedData = Table1.map((report, index) => ({
                        sharedBy: Table1[index]?.shared_to,
                        relationType: report.relation_type,
                        reportName: Table1[index]?.report_name,
                        sharedOn: Table1[index]?.shared_on,
                        validUpTo: Table1[index]?.valid_up_to,
                        reportID: Table1[index]?.report_id,
                        share_id: Table1[index]?.share_id, // Add share_id for revoke functionality
                        notes: Table1[index]?.notes || "NA"
                    }));
                    setSharedReportsData(combinedData);
                })
                .catch((error) => {
                    console.error("Error fetching shared reports:", error);
                    setError(true);
                })
                .finally(() => setLoading(false));
        } else if (activeTab === "Request Access") {
            fetchRequestAccessData();
        } else if (activeTab === "Approve Access") {
            setLoading(true);
            dispatch(InternalSharedReportsFromOthersComplete(params))
                .then((response) => {

                    if (!response.payload) {
                        console.error("No payload in response");
                        setError(true);
                        return;
                    }

                    const tableData = response.payload.Table1 || response.payload;

                    if (!Array.isArray(tableData)) {
                        console.error("Table data is not an array:", tableData);
                        setError(true);
                        return;
                    }

                    const combinedData = tableData.map((report) => {
                        return {
                            shared_to_user: report.shared_to_user || report.shared_to || '',
                            sharedBy: report.requested_from_user || report.shared_by_user || report.shared_by || '',
                            sharedOn: report.shared_on || '',
                            validUpTo: report.approved_on || '',
                            shared_from_id: report.shared_from_id || '',
                            share_id: report.share_id || '',
                            reportName: report.report_name || '',
                            approved: report.approved_yn, // Keep null/undefined as is, don't default to false
                            notes: report.notes || "NA"
                        };
                    });

                    setSharedReportsData(combinedData);
                    setLstReportsFromOthersComplete(combinedData);
                })
                .catch((error) => {
                    console.error("Error fetching shared reports:", error);
                    setError(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
        else if (activeTab === "Share Everywhere") {
            setLoading(true);
            Promise.all([
                dispatch(ReportCategoriesGet(params)),
                dispatch(getMRSitesReports(params)),
                dispatch(SharedReportValidityGet(params))
            ])
                .then(([categoriesResponse, reportsResponse, validityResponse]) => {
                    // console.log(categoriesResponse, "categoriesResponse");
                    // console.log(reportsResponse, "reportsResponse");
                    // console.log(validityResponse, "validityResponse");
                    const categoriesData = categoriesResponse.payload.Table.map((report) => ({
                        Name: report.name,
                        id: report.id,
                    }));
                    setSharedReportsData(categoriesData);

                    const reportsData = reportsResponse.payload.Table.map((report) => ({
                        GroupName: report.report_name,
                        group: report.group_name,
                        groupid: report.report_id,
                        providerName: report.provider_name,
                    }));
                    setSubItemsMap(reportsData);
                    // console.log(reportsData, "reportsData");

                    // Set validity options and default value
                    const validityData = validityResponse.payload.Table.map((report) => ({
                        Duration: report.duration,
                        id: report.id,
                    }));
                    setValidityOptions(validityData);
                    if (validityData.length > 0) {
                        setSelectedValidity(validityData[0].id);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError(true);
                })
                .finally(() => setLoading(false));
        }
    }, [activeTab, dispatch, userId, token, revokedShareIds, fetchRequestAccessData]);

    const [activeCodes, setActiveCodes] = useState([]);
    const [localSubitemCodes, setLocalSubitemCodes] = useState([]);

    const parseActiveCodesPayload = (payload) => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        if (Array.isArray(payload.Table)) return payload.Table;
        return [];
    };

    const loadQRCodesForActiveCodes = useCallback((data) => {
        if (!data?.length) {
            setQRCodeUrls({});
            return;
        }

        setShowQRCode(true);
        const qrPromises = data.map((item) => {
            const { EveryWhereShareID, ShareCode } = item;
            if (!ShareCode) return null;

            const qrParams = {
                shareId: EveryWhereShareID,
                token,
                user_id: userId
            };

            return dispatch(shareReportQRCodeURL(qrParams))
                .then((response) => {
                    const base64String = response?.payload?.base64String;
                    if (base64String) {
                        return {
                            shareId: EveryWhereShareID,
                            qrUrl: `data:image/png;base64,${base64String}`
                        };
                    }
                    return null;
                })
                .catch((error) => {
                    console.error(`QR code generation failed for shareId: ${EveryWhereShareID}`, error);
                    return null;
                });
        });

        Promise.all(qrPromises)
            .then((qrResults) => {
                const validResults = qrResults.filter(Boolean);
                const qrCodeMap = validResults.reduce((acc, { shareId, qrUrl }) => {
                    acc[shareId] = qrUrl;
                    return acc;
                }, {});
                setQRCodeUrls(qrCodeMap);
            });
    }, [dispatch, token, userId]);

    const fetchActiveCodesFromAPI = useCallback(({ syncToggle = false, forceLoadQR = false } = {}) => {
        const params = { token, user_id: userId };
        dispatch(sharedReportsValidCodesGet(params))
            .then((res) => {
                const data = parseActiveCodesPayload(res?.payload);
                setActiveCodes(data);

                if (syncToggle) {
                    setShowActiveCodes(data.length > 0);
                }

                if (data.length === 0) {
                    setQRCodeUrls({});
                    return;
                }

                if (syncToggle || forceLoadQR || showActiveCodesRef.current) {
                    loadQRCodesForActiveCodes(data);
                }
            })
            .catch((err) => {
                console.error("Error fetching valid codes:", err);
                setError("Failed to fetch valid codes");
            });
    }, [dispatch, token, userId, loadQRCodesForActiveCodes]);

    const handleToggle = () => {
        const newState = !showActiveCodes;
        setShowActiveCodes(newState);

        if (newState) {
            fetchActiveCodesFromAPI({ forceLoadQR: true });
        } else {
            setActiveCodes([]);
            setQRCodeUrls({});
        }
    };

    const handleCopy = (code) => {
        navigator.clipboard.writeText(code);
        toast.success('Code copied to clipboard!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        // Removed alert popup - just copy silently
    };

    const [userOptions, setUserOptions] = useState([]); // For dropdown
    const [selectedUser, setSelectedUser] = useState([]); // For selected user object

    // Debounced search function
    const handleFamilySearch = useCallback(
        debounce((query) => {
            const trimmed = query.trim();
            if (!trimmed) {
                setUserOptions([]);
                return;
            }
            const params = {
                user_id: userId,
                token: token,
                SearchKey: trimmed,
            };
            dispatch(familyMembersUsersGet(params))
                .then((resp) => {
                    setUserOptions(resp.payload.Table || []);
                })
                .catch(() => setUserOptions([]));
        }, 400),
        [dispatch, userId, token]
    );

    const onAccessRequest = async (data) => {
        setSubmitClicked(true);

        // selectedUser is an array from Typeahead, take the first item
        const userObj = selectedUser[0];

        if (!userObj) {
            setIsUserSelectionInvalid(true);
            return;
        }

        const formData = {
            SharedToEmail: userData.email_address,
            LoginUserID: userObj.user_id,
            ShareNotes: data.notes,
            ShareToEmail: userData.email_address,
            token: token // Add the token from userData
        };

        try {
            // 1. Check if request already exists
            const checkResp = await dispatch(
                InternalSharedReportAccessCheck(formData)
            ).unwrap();

            // if (checkResp && checkResp.length > 0) {
            //     setRequestModalMessage(checkResp);
            //     setRequestModalType('alert');
            //     setShowRequestModal(true);
            //     return;
            // }
            if (checkResp && checkResp.length > 0) {
                showPmrError({ title: 'Error', message: checkResp });
                return;
            }

            // 2. If not, save the request
            const saveResp = await dispatch(
                InternalSharedReportSave(formData)
            ).unwrap();

            // setRequestModalMessage(
            //     `The request for access to the reports was successfully sent to ${userObj.user_name}.`
            // );
            // setRequestModalMessage(
            //     <>The request for access to the reports was successfully sent to <strong className="fw-bold">{userObj.user_name}</strong>.</>
            // );

            showPmrSuccess({
                html: `<div class="pmr-popup-message">The request for access to the reports was successfully sent to <b>${userObj.user_name}</b>.</div>`,
                timer: 2000,
            });
            setSelectedUser([]);
            setIsUserSelectionInvalid(false);
            if (typeaheadRef.current) {
                typeaheadRef.current.clear();
            }
            reset();
            fetchRequestAccessData();

        } catch (error) {
            showPmrError('An error occurred while requesting access.');
            setRequestModalType('alert');
            setShowRequestModal(true);
        }
    };

    const search = (query) => {
        // Implement your search logic here
    };

    const handleSubItemCheckboxChange = (subItemId) => {
        // Clear selection error when user starts selecting items
        if (selectionError) {
            setSelectionError(false);
        }

        setSelectedSubItems((prev) => {
            const newSelectedSubItems = prev.includes(subItemId)
                ? prev.filter((id) => id !== subItemId)
                : [...prev, subItemId];

            // Find the category this subitem belongs to
            const subItem = subItemsMap.find(item => item.groupid === subItemId);
            if (subItem) {
                const categoryName = subItem.group;
                const category = sharedReportsData.find(r => r.Name === categoryName);

                if (category) {
                    // Get all subitems for this category
                    const categorySubItems = subItemsMap
                        .filter(item => item.group === categoryName)
                        .map(item => item.groupid);

                    // Check if all subitems for this category are selected
                    const allCategorySubItemsSelected = categorySubItems.every(itemId =>
                        newSelectedSubItems.includes(itemId)
                    );

                    // Update parent category selection
                    setSelectedReports(prevReports => {
                        let newSelectedReports = [...prevReports];

                        if (allCategorySubItemsSelected) {
                            // Add category if not already selected
                            if (!newSelectedReports.includes(category.id)) {
                                newSelectedReports.push(category.id);
                            }
                        } else {
                            // Remove category if it was selected
                            newSelectedReports = newSelectedReports.filter(id => id !== category.id);
                            // Also remove "Select All" if it was selected
                            newSelectedReports = newSelectedReports.filter(id => id !== 0);
                        }

                        // Check if all categories are now selected
                        const allIndividualReports = sharedReportsData.filter(r => r.id !== 0).map(r => r.id);
                        const allCategoriesSelected = allIndividualReports.every(reportId =>
                            newSelectedReports.includes(reportId)
                        );

                        // Check if all subitems are selected
                        const allSubItemIds = subItemsMap.map(item => item.groupid);
                        const allSubItemsSelected = allSubItemIds.every(itemId =>
                            newSelectedSubItems.includes(itemId)
                        );

                        // Add "Select All" if all categories and subitems are selected
                        if (allCategoriesSelected && allSubItemsSelected && !newSelectedReports.includes(0)) {
                            newSelectedReports.push(0);
                        }

                        return newSelectedReports;
                    });
                }
            }

            return newSelectedSubItems;
        });
    };

    useEffect(() => {
        if (props.activeSharedTab) {
            setActiveTab(props.activeSharedTab);
        }
    }, [props.activeSharedTab]);

    const onFullScreenToggle = () => {
        const elem = previewContainerRef.current;
        if (!elem) {
            console.error('Preview container ref not found');
            return;
        }

        if (!document.fullscreenElement) {
            elem.requestFullscreen()
                .then(() => {
                    setIsFullscreen(true);
                })
                .catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
                    .then(() => {
                        setIsFullscreen(false);
                    })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                    });
            } else {
                console.error("Exit fullscreen is not supported by this browser.");
            }
        }
    };


    const onFullScreenToggleTabs = () => {
        // Get the main content div instead of the PDF preview container
        const mainContentDiv = document.querySelector('.main-content-container');
        if (!mainContentDiv) {
            console.error('Main content container not found');
            return;
        }

        if (!document.fullscreenElement) {
            mainContentDiv.requestFullscreen()
                .then(() => {
                    setIsFullscreen(true);
                })
                .catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
                    .then(() => {
                        setIsFullscreen(false);
                    })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                    });
            } else {
                console.error("Exit fullscreen is not supported by this browser.");
            }
        }
    };

    // Add fullscreen change event listeners
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // Debug useEffect for ref and showPDF
    useEffect(() => {
    }, [showPDF, previewContainerRef.current]);


    const copyToClipboard = () => {
        if (generatedCode) {
            navigator.clipboard.writeText(codeGenerated);
            toast.success('Code copied to clipboard!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    useEffect(() => {
        showActiveCodesRef.current = showActiveCodes;
    }, [showActiveCodes]);

    // Auto ON/OFF "Show active codes" when Share Everywhere tab is open (active list → ON, empty → OFF).
    useEffect(() => {
        if (activeTab === "Share Everywhere") {
            fetchActiveCodesFromAPI({ syncToggle: true });
        }
    }, [activeTab, userId, fetchActiveCodesFromAPI]);

    // When the family dropdown changes the effective user, close With You / By You PDF preview.
    useEffect(() => {
        clearPdfPreview();
        setShowModal(false);
    }, [userId]);

    useEffect(() => {
        if (showSuccessModal) {
            showPmrSuccess({ message, timer: 2000 }).then(() => setShowSuccessModal(false));
        }
    }, [showSuccessModal, message]);

    return (
        <>
            <div>
                <div className="d-lg-flex d-md-block d-sm-block gap-3 d-block" style={{ minHeight: 'calc(100vh - 205px)', }} >
                    <div
                        className={`bg-white rounded shadow-lg py-3 px-3 main-content-container ${showPDF ? "col-lg-6 col-md-12 col-sm-12 col-12" : "col-lg-12 col-md-12 col-sm-12 col-12"}`}
                        style={{

                            overflow: 'hidden'
                        }}
                    >
                        {showTabs && (
                            <div >
                                <div className="justify-content-between align-items-center">
                                    <h5 className="mb-2 text-capitalize">Shared Reports</h5>
                                </div>
                                <ul className="nav border-0 d-flex px-2" style={{ marginBottom: '0', borderBottom: '1px solid #e5e7eb', flexWrap: 'nowrap' }}>
                                    {tabs.map((tab) => (
                                        <li className="nav-item" key={tab}>
                                            <button
                                                className="nav-link border-0 px-3"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: activeTab === tab ? 'var(--pmr-primary)' : 'var(--pmr-text)',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    border: 'none',
                                                    borderRadius: '0',
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    outline: 'none',
                                                    boxShadow: 'none'
                                                }}
                                                onClick={() => handleTabClick(tab)}
                                            >
                                                {tab}
                                                {activeTab === tab && (
                                                    <div className="bluegradient" style={{
                                                        position: 'absolute',
                                                        bottom: '1.5px',
                                                        left: '0',
                                                        right: '0',
                                                        height: '3px',
                                                        zIndex: 10
                                                    }}></div>
                                                )}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        )}

                        {/* With you tab content */}
                        {activeTab === "With You" && (
                            <div

                                className="row px-2 ag-theme-balham"
                                style={{
                                    minHeight: 'calc(95vh - 200px)',
                                }}
                            >
                                <div
                                    className=""

                                    style={{
                                        // take full height inside parent div

                                        maxHeight: '100%',          // max height constrained by parent
                                        overflowY: 'auto',          // scroll only when needed
                                    }}
                                >
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <StethoscopeLoading message="Loading..." />
                                        </div>
                                    ) : sharedReportsData.length > 0 ? (
                                        <>

                                            <AgGridReact
                                                enableBrowserTooltips={true}
                                                tooltipShowDelay={0}
                                                rowData={sharedReportsData}
                                                columnDefs={withYouColumns}
                                                defaultColDef={{
                                                    sortable: true,
                                                    filter: true,
                                                    headerClass: 'ag-header-with-border'
                                                }}
                                                domLayout='normal'
                                                animateRows={true}
                                                modules={[ClientSideRowModelModule]}
                                                onRowClicked={handleReportClick}
                                                rowClass={(params) => {
                                                    return params.rowIndex === selectedRow ? 'ag-row-selected' : '';
                                                }}
                                                getRowStyle={(params) => {
                                                    const isEven = params.rowIndex % 2 === 0;
                                                    const isSelected = params.rowIndex === selectedRow;

                                                    if (isSelected) {
                                                        return {
                                                            backgroundColor: 'var(--pmr-grid-row-hover)',
                                                            border: 'none',
                                                            borderBottom: '1px solid #ddd'
                                                        };
                                                    }

                                                    return {
                                                        backgroundColor: isEven ? '#ffffff' : 'var(--pmr-bg-grid)',
                                                        border: 'none',
                                                        borderBottom: '1px solid #ddd'
                                                    };
                                                }}
                                            />


                                        </>
                                    ) : (
                                        <div className="border-0 h-100">
                                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh", height: "50vh", maxHeight: "70vh" }}>
                                                <p className="text-muted m-0 fw-bold" style={{ color: "var(--pmr-text)" }}>No reports to view.</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* By you tab content */}
                        {activeTab === "By You" && (
                            <div
                                className="row px-2 ag-theme-balham"
                                style={{
                                    minHeight: 'calc(95vh - 200px)',
                                }}
                            >
                                <div
                                    style={{
                                        maxHeight: '100%',
                                        overflowY: 'auto',
                                    }}
                                >

                                    {loading ? (
                                        <div className="text-center py-5">
                                            <StethoscopeLoading message="Loading..." />
                                        </div>
                                    ) : sharedReportsData.length > 0 ? (
                                        <AgGridReact
                                            enableBrowserTooltips={true}
                                            tooltipShowDelay={0}
                                            rowData={sharedReportsData}
                                            columnDefs={byYouColumns}
                                            defaultColDef={{ sortable: true, filter: true }}
                                            animateRows={true}
                                            modules={[ClientSideRowModelModule]}
                                            onRowClicked={handleReportClick}
                                            rowClass={(params) => {
                                                return params.rowIndex === selectedRow ? 'ag-row-selected' : '';
                                            }}
                                            getRowStyle={(params) => {
                                                const isEven = params.rowIndex % 2 === 0;
                                                const isSelected = params.rowIndex === selectedRow;

                                                if (isSelected) {
                                                    return {
                                                        backgroundColor: 'var(--pmr-grid-row-hover)',
                                                        border: 'none',
                                                        borderBottom: '1px solid #dee2e6'
                                                    };
                                                }

                                                return {
                                                    backgroundColor: isEven ? '#ffffff' : 'var(--pmr-bg-grid)',
                                                    border: 'none',
                                                    borderBottom: '1px solid #dee2e6'
                                                };
                                            }}
                                        />

                                    ) : (
                                        <div className="border-0 h-100">
                                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh", height: "50vh", maxHeight: "70vh" }}>
                                                <p className="text-muted m-0 fw-bold" style={{ color: "var(--pmr-text)" }}>No reports to view.</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        )}

                        {isProvider && (
                            (activeTab === "Request Access") && (
                                <>
                                    {loading ? (
                                        <div className="text-center py-5" style={{ minHeight: 'calc(95vh - 200px)' }}>
                                            <StethoscopeLoading message="Loading..." />
                                        </div>
                                    ) : (
                                        <div className="row business-items mb-1 d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(95vh - 200px)' }}>
                                            <div className="col-12 p-0 mb-1">
                                                <Form onSubmit={handleSubmit(onAccessRequest)} autoComplete="off">
                                                    <div className="input-group mb-50 py-1 px-3">
                                                        <Typeahead
                                                            ref={typeaheadRef}
                                                            id="patient_name"
                                                            labelKey="user_name"
                                                            options={userOptions}
                                                            placeholder="Please search by name or email address"
                                                            onInputChange={(query) => {
                                                                handleFamilySearch(query);
                                                                if (query.trim()) {
                                                                    setIsUserSelectionInvalid(false);
                                                                }
                                                            }}
                                                            onChange={(selected) => {
                                                                setSelectedUser(selected);
                                                                if (selected.length > 0) {
                                                                    setIsUserSelectionInvalid(false);
                                                                }
                                                            }}
                                                            selected={selectedUser}
                                                            minLength={2}
                                                            renderMenuItemChildren={(option) => (
                                                                <div>
                                                                    <span>{option.user_name}</span>
                                                                    <div>
                                                                        <small>{option.email}</small>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            className={`text-info text-left col-12 ${isUserSelectionInvalid && !loading && activeTab === "Request Access" ? 'is-invalid' : ''}`}
                                                        />
                                                    </div>

                                                    <div className="col-12 p-0 py-1 px-3">
                                                        <Form.Control
                                                            as="textarea"
                                                            id="notes"
                                                            placeholder="Notes"
                                                            {...register('notes', { required: false })}
                                                            style={{ height: '70px' }}
                                                            className={`form-control form-input w-full ${submitClicked && errors.notes ? 'is-invalid' : ''}`}
                                                        />
                                                    </div>

                                                    <div className="col-12 p-0  d-flex align-items-center justify-content-end mt-2 px-3">
                                                        <Button type="submit" className="col-12 col-lg-2 col-md-3 col-sm-4 btn btn-primary" >
                                                            Request Access for Reports
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </div>

                                            <div
                                                className="table-responsive ag-theme-balham p-2 bg-white  rounded  px-3"

                                            >
                                                {lstReportsFromOthersComplete?.length > 0 ? (
                                                    <div
                                                        className="ag-theme-balham"
                                                        style={{
                                                            height: 'calc(50vh - 10px)',
                                                            width: '100%',
                                                            overflowY: 'auto',
                                                            overflowX: 'hidden',
                                                        }}
                                                    >
                                                        <AgGridReact
                                                            rowData={lstReportsFromOthersComplete}
                                                            columnDefs={columnDefs}
                                                            enableBrowserTooltips={true}
                                                            tooltipShowDelay={0}
                                                            defaultColDef={{
                                                                sortable: true,
                                                                filter: true,
                                                                resizable: true,
                                                                minWidth: 80,
                                                                headerClass: 'ag-center-header'
                                                            }}

                                                            headerHeight={27}
                                                            rowHeight={28}
                                                            style={{ height: '100%', width: '100%' }}
                                                            rowClass={(params) => {
                                                                return params.rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
                                                            }}
                                                            getRowStyle={(params) => {
                                                                return {
                                                                    backgroundColor: params.rowIndex % 2 === 0 ? '#ffffff' : 'var(--pmr-bg-grid)',
                                                                    border: 'none',
                                                                    borderBottom: '1px solid #dee2e6'
                                                                };
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="border-0 h-100">
                                                        <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(50vh - 10px)' }}>
                                                            <p className="text-muted m-0 fw-bold" style={{ color: "var(--pmr-text)" }}>No reports to view.</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    )}
                                </>
                            )
                        )}

                        {/* Approve Access tab content */}
                        {activeTab === "Approve Access" && (
                            <div
                                className="row px-2 ag-theme-balham"
                                style={{
                                    minHeight: 'calc(95vh - 200px)',
                                }}
                            >
                                <div
                                    style={{
                                        maxHeight: '100%',
                                        overflowY: 'auto',
                                    }}
                                >


                                    {loading ? (
                                        <div className="text-center py-5">
                                            <StethoscopeLoading message="Loading..." />
                                        </div>
                                    ) : sharedReportsData.length > 0 ? (
                                        <AgGridReact
                                            rowData={sharedReportsData}
                                            columnDefs={approveAccessColumns}
                                            defaultColDef={{ sortable: true, filter: true }}
                                            animateRows={true}
                                            modules={[ClientSideRowModelModule]}
                                            enableBrowserTooltips={true}
                                            tooltipShowDelay={0}
                                            rowClass={(params) => {
                                                return params.rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
                                            }}
                                            getRowStyle={(params) => {
                                                return {
                                                    backgroundColor: params.rowIndex % 2 === 0 ? '#ffffff' : 'var(--pmr-bg-grid)',
                                                    border: 'none',
                                                    borderBottom: '1px solid #dee2e6'
                                                };
                                            }}
                                        />

                                    ) : (
                                        <div className="border-0 h-100">
                                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh", height: "50vh", maxHeight: "70vh" }}>
                                                <p className="text-muted m-0 fw-bold" style={{ color: "var(--pmr-text)" }}>No reports to view.</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}


                        {/* Share Everywhere tab content */}
                        {activeTab === "Share Everywhere" && (
                            <div
                                className="row px-2"
                                style={{
                                    minHeight: 'calc(95vh - 200px)',
                                }}
                            >
                                <div
                                    style={{
                                        maxHeight: '100%',
                                        overflowY: 'auto',
                                    }}
                                >

                                    {loading ? (
                                        <div className="text-center py-2">
                                            <StethoscopeLoading message="Loading..." />
                                        </div>
                                    ) : sharedReportsData.length > 0 && subItemsMap.length > 0 ? (
                                        <div className=''>
                                            {/* <Card className="d-flex border-0 p-0 shadow-lg bg-white"> */}
                                            <div className="row p-0">
                                                {/* LEFT COLUMN */}
                                                <div className=" col-lg-5 col-md-5 col-sm-12 col-xs-12 p-3" style={{ color: "var(--pmr-text-heading)" }}>
                                                    <div className="mb-2">
                                                        <span className="fw-bold">Select categories to share the reports</span>
                                                    </div>
                                                    <div className="mb-3">
                                                        {sharedReportsData.map((report) => (
                                                            <div
                                                                key={report.id}
                                                                className="d-flex flex-column bg-white "
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        className={`form-check-input me-2 ${selectedReports.includes(report.id) ? "" : ""}`}
                                                                        type="checkbox"
                                                                        id={`report-${report.id}`}
                                                                        checked={
                                                                            report.id === 0
                                                                                ? sharedReportsData
                                                                                    .filter((r) => r.id !== 0)
                                                                                    .every((r) => selectedReports.includes(r.id))
                                                                                : selectedReports.includes(report.id)
                                                                        }
                                                                        onChange={() => handleCheckboxChange(report.id)}
                                                                    />
                                                                    {report.id !== 0 && (
                                                                        <img
                                                                            src={downarrow}
                                                                            className={`me-2 mt-2 ${openDropdowns.includes(report.id) ? "rotate-180" : ""}`}
                                                                            onClick={() => toggleDropdown(report.id)}
                                                                            alt="dropdown"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                width: "15px",
                                                                                transform: openDropdowns.includes(report.id) ? "rotate(0deg)" : "rotate(-90deg)",
                                                                                transition: "transform 0.3s ease",
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <label htmlFor={`report-${report.id}`} className="mb-0 fw-bold">
                                                                        {report.Name}
                                                                    </label>
                                                                </div>
                                                                {openDropdowns.includes(report.id) && (
                                                                    <div className="mt-2 ms-4">
                                                                        {(subItemsMap
                                                                            .filter((subItem) => subItem.group === report.Name)
                                                                            .filter((subItem, index, self) =>
                                                                                index === self.findIndex((s) => s.groupid === subItem.groupid)
                                                                            ) || []).map((subItem, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    className="form-check ms-3 d-flex align-items-center"
                                                                                >
                                                                                    <div >
                                                                                        <input
                                                                                            className="form-check-input me-2"
                                                                                            type="checkbox"
                                                                                            id={`subitem-${report.id}-${subItem.groupid}`}
                                                                                            checked={selectedSubItems.includes(subItem.groupid)}
                                                                                            onChange={() => handleSubItemCheckboxChange(subItem.groupid)}
                                                                                        />
                                                                                        <div className="d-flex align-items-center">
                                                                                            <label
                                                                                                className="form-check-label me-2 fw-bold"
                                                                                                htmlFor={`subitem-${report.id}-${subItem.groupid}`}
                                                                                            >
                                                                                                {subItem.GroupName}
                                                                                                {
                                                                                                    subItem.providerName && !subItem.GroupName.includes(subItem.providerName)
                                                                                                        ? ` - ${subItem.providerName}`
                                                                                                        : ''
                                                                                                }                                                                                            </label>
                                                                                            <FaEye className="ms-1"
                                                                                                style={{ cursor: "pointer", color: "var(--pmr-primary)" }}
                                                                                                title="Preview"
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    e.preventDefault();
                                                                                                    handleEyeClick(subItem.GroupName, subItem.groupid);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                        {isCategoryInvalid && (
                                                            <Form.Text className="text-danger fw-bold">
                                                                Please select at least one category to share
                                                            </Form.Text>
                                                        )}
                                                    </div>

                                                    <Form>
                                                        <div className="row g-3 mb-4">
                                                            <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                                                                <Form.Group controlId="shareWith">
                                                                    <Form.Label >Share With Name:</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter name"
                                                                        value={shareName}
                                                                        onChange={(e) => setShareName(e.target.value)}
                                                                        className={`border rounded shadow-sm ${isNameInvalid ? "border-danger" : "border-dark"}`}
                                                                        style={{
                                                                            height: "40px",
                                                                            minHeight: "40px",
                                                                            maxHeight: "40px",
                                                                        }}
                                                                    />
                                                                    {isNameInvalid && (
                                                                        <Form.Text className="text-danger fw-bold">
                                                                            Please enter a name to share
                                                                        </Form.Text>
                                                                    )}

                                                                </Form.Group>
                                                            </div>
                                                            <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                                                                <Form.Group controlId="validity">
                                                                    <Form.Label>Validity:</Form.Label>
                                                                    <Form.Select
                                                                        value={selectedValidity}
                                                                        onChange={(e) => setSelectedValidity(e.target.value)}
                                                                        disabled={checkboxesDisabled}
                                                                    >
                                                                        {validityOptions.map((option, id) => (
                                                                            <option key={id} value={option.id}>
                                                                                {option.Duration}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                        {!generatedCode && (
                                                            <Button
                                                                type="button"
                                                                variant="primary"
                                                                onClick={handleGenerateCode}
                                                                disabled={loading}
                                                            >
                                                                {loading ? (
                                                                    <>
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                            className="me-2"
                                                                        />
                                                                        Generating...
                                                                    </>
                                                                ) : (
                                                                    'Generate Code'
                                                                )}
                                                            </Button>
                                                        )}
                                                        {generatedCode && (
                                                            <div className="mt-3">
                                                                <div className="align-items-center row">
                                                                    <div className="border p-2 bg-white rounded col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12">
                                                                        <h2 className="mb-0 fw-bold">{codeGenerated}</h2>
                                                                    </div>
                                                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12">
                                                                        {generatedCode && (
                                                                            <>
                                                                                <div className="d-lg-flex d-md-flex d-sm-block d-xs-block align-items-center gap-2 justify-content-center">
                                                                                    {/* Copy to Clipboard */}
                                                                                    <span data-tooltip-id="tooltip-copy" data-tooltip-content="Copy Code to Clipboard">
                                                                                        <FontAwesomeIcon
                                                                                            icon={faCopy}
                                                                                            className="cursor-pointer"
                                                                                            onClick={copyToClipboard}
                                                                                            style={{
                                                                                                width: '24px',
                                                                                                height: '24px',
                                                                                                color: 'var(--pmr-secondary)',
                                                                                                cursor: 'pointer'
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                    <Tooltip id="tooltip-copy" />

                                                                                    {/* Share via Email */}
                                                                                    <span data-tooltip-id="tooltip-email" data-tooltip-content="Share via Email">
                                                                                        <i
                                                                                            className="fa fa-envelope cursor-pointer mx-1 text-info share-generate-code-icon"
                                                                                            onClick={() => setShowComingSoonModal(true)}
                                                                                        ></i>
                                                                                    </span>
                                                                                    <Tooltip id="tooltip-email" />

                                                                                    {/* Share via SMS */}
                                                                                    <span data-tooltip-id="tooltip-sms" data-tooltip-content="Share via SMS">
                                                                                        <FontAwesomeIcon
                                                                                            icon={faTelegram}
                                                                                            className="cursor-pointer"
                                                                                            onClick={() => setShowComingSoonModal(true)}
                                                                                            style={{
                                                                                                width: '24px',
                                                                                                height: '24px',
                                                                                                color: 'var(--pmr-danger)',
                                                                                                cursor: 'pointer'
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                    <Tooltip id="tooltip-sms" />
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                                        {qrCodeUrl && (

                                                                            <img
                                                                                src={qrCodeUrl}
                                                                                alt="QR Code"
                                                                                width="170"
                                                                                height="170"
                                                                            />

                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <canvas
                                                                    ref={canvasRef}
                                                                    width="200"
                                                                    height="80"
                                                                    className="d-none"
                                                                ></canvas>
                                                                {expirationMessage && <p className="text-danger mt-3 fw-semibold">{expirationMessage}</p>}
                                                                {expiryDate && <p className="text-info mt-2 fw-semibold">{expiryDate}</p>}
                                                                <Button variant="primary" className="me-2" onClick={handleNewCode}>
                                                                    New Code
                                                                </Button>
                                                                <Button variant="danger" onClick={handleCancelCode}>
                                                                    Cancel
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </Form>
                                                    <Modal
                                                        show={showModal}
                                                        onHide={() => setShowModal(false)}
                                                        dialogClassName="custom-modal-dialog wider-modal"
                                                        contentClassName="custom-modal-content"
                                                        backdropClassName="bg-dark bg-opacity-50"
                                                        keyboard={false}
                                                        centered
                                                    >
                                                        <Modal.Header className="custom-modal-header d-flex" closeButton>
                                                            <Modal.Title>
                                                                <span className="fw-bold" style={{ color: "var(--pmr-text-heading)" }}>Selected Report - </span><span className="fw-bold" style={{ color: "var(--pmr-text-heading)", fontWeight: "900" }}>{selectedGroupName}</span>
                                                            </Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body className="custom-modal-body">
                                                            {isReportPreviewLoading ? (
                                                                <StethoscopeLoading className="h-100" message="Loading report preview..." />
                                                            ) : pdfUrl && (isDocxContentType(previewContentType) || isDocxFileName(selectedGroupName)) ? (
                                                                <ReportFileBody
                                                                    pdfUrl={pdfUrl}
                                                                    fileName={selectedGroupName}
                                                                    contentType={previewContentType}
                                                                    className="pdf-iframe"
                                                                    title="PDF Preview"
                                                                />
                                                            ) : pdfUrl ? (
                                                                <iframe
                                                                    key={pdfUrl}
                                                                    src={getPdfViewerSrc(pdfUrl)}
                                                                    className="pdf-iframe"
                                                                    title="PDF Preview"
                                                                />
                                                            ) : (
                                                                <div className="d-flex align-items-center justify-content-center h-100">
                                                                    <p>Loading or no PDF available.</p>
                                                                </div>
                                                            )}
                                                        </Modal.Body>
                                                    </Modal>
                                                </div>

                                                {/* RIGHT COLUMN */}
                                                <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 p-4" style={{ background: "white", color: "var(--pmr-text-heading)" }}>
                                                    <div className="form-switch d-flex align-items-center mb-2" >
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="activeCodes"
                                                            checked={showActiveCodes}
                                                            onChange={handleToggle}
                                                            role="switch"
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: showActiveCodes ? "#003b87" : "#dee2e6",
                                                                borderColor: showActiveCodes ? "#003b87" : "#dee2e6",
                                                                boxShadow: "none",
                                                                border: "none",
                                                                borderRadius: "10px",
                                                            }}
                                                        />
                                                        <label className="form-check-label ms-2" htmlFor="activeCodes">
                                                            Show active codes
                                                        </label>
                                                    </div>
                                                    <div style={{ maxHeight: 'calc(85vh - 230px)', overflow: 'auto' }}>
                                                        {showActiveCodes && activeCodes.map((code, index) => (
                                                            <div
                                                                key={index}
                                                                className="p-2 mb-3 d-flex justify-content-start align-items-start"
                                                                style={{ backgroundColor: code.IsAccessed ? '#f6f0e3' : '#e6f3e3' }}
                                                            >
                                                                <div className="flex-grow-1 w-50">
                                                                    <p className="mb-1 fs-6 ">
                                                                        <strong className="text-primary">Categorie(s): </strong>{code.CategoryNames}
                                                                    </p>
                                                                    <p className="mb-1 fs-6">
                                                                        <strong className="text-primary">Name: </strong>{code.ShareWithName}
                                                                    </p>
                                                                    <p className="mb-1">
                                                                        <strong className="text-primary">Code: </strong>
                                                                        <span className="border border-secondary px-2 py-1 rounded fw-bold me-2">
                                                                            {code.ShareCode}
                                                                        </span>
                                                                        {/* <button onClick={() => handleCopy(code.ShareCode)} >📋</button> */}
                                                                        <span>
                                                                            <FontAwesomeIcon
                                                                                icon={faCopy}
                                                                                className="btn btn-sm btn" onClick={() => handleCopy(code.ShareCode)}
                                                                                style={{
                                                                                    width: '16px',
                                                                                    height: '16px',
                                                                                    color: '#003b87',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            />
                                                                        </span>

                                                                    </p>
                                                                </div>
                                                                <div className=" flex-grow-1 text-end fs-6 w-50">
                                                                    <p className="mb-1">
                                                                        <strong className="text-primary">Created On: </strong>{code.CreatedOn}
                                                                    </p>
                                                                    <p className="mb-1">
                                                                        <strong className="text-primary">Valid Upto: </strong>{code.ValidUpto}
                                                                    </p>
                                                                    <p className="mb-1">
                                                                        <strong className="text-primary">Accessed: </strong>{code.IsAccessed ? 'Yes' : 'No'}
                                                                    </p>
                                                                </div>
                                                                <div className="p-1" style={{ width: '150px' }}>
                                                                    {(qrCodeUrls[code.EveryWhereShareID] || code.qrCodeUrl) && (
                                                                        <img
                                                                            src={qrCodeUrls[code.EveryWhereShareID] || code.qrCodeUrl}
                                                                            alt={`QR Code for ${code.ShareCode}`}
                                                                            width="150"
                                                                            height="130"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </Card.Body>
                                            </Card> */}
                                        </div>
                                    ) : (
                                        <div className="border-0 h-100">
                                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh", height: "50vh", maxHeight: "70vh" }}>
                                                <p className="text-muted m-0">No reports available to share.</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        )}

                        {showReportDisplayModal && (
                            <ReportDisplaySection
                                onClose={() => setShowReportDisplayModal(false)}
                                rowData={rowData}
                            />
                        )}
                        {showPatientSummaryModal && (
                            <PatientSummarySection
                                onClose={() => setShowPatientSummaryModal(false)}
                            />
                        )}
                        {isProviderReports && (
                            <ViewReports />
                        )}
                    </div>

                    {showPDF && (
                        <div
                            className="px-1"
                            style={{

                                width: '100%',

                            }}

                        >
                            <div

                                style={{

                                    maxHeight: '100%',          // max height constrained by parent
                                    overflowY: 'auto',          // scroll only when needed
                                    width: '100%',
                                }}
                            >
                                <PDFPreviewPanel
                                    ref={previewContainerRef}
                                    pdfUrl={pdfUrl}
                                    selectedReportName={selectedReportName}
                                    contentType={previewContentType}
                                    notes={selectedRowData?.notes || "NA"}
                                    validUpTo={selectedRowData?.validUpTo}
                                    onClear={onClear}
                                    onFullScreenToggle={onFullScreenToggle}
                                    isFullscreen={isFullscreen}
                                    onNotesClick={handleNotesClick}
                                    isLoading={isReportPreviewLoading}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showComingSoonModal && (
                <div className="custom-modal-overlay">
                    <div
                        className="custom-modal"
                        style={{ width: '480px', textAlign: 'center', padding: '32px 32px' }}
                    >
                        <div style={{ marginBottom: 24 }}>
                            <div
                                style={{
                                    width: 80,
                                    height: 80,
                                    borderRadius: '50%',
                                    border: '3px solid #f9c89b',
                                    margin: '0 auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <span style={{ fontSize: 48, color: '#f9c89b' }}>!</span>
                            </div>
                        </div>
                        <h4 style={{ fontWeight: 600, marginBottom: 12 }}>Coming Soon</h4>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: '#003366',
                                    color: 'white',
                                    minWidth: 100,
                                    fontWeight: 500
                                }}
                                onClick={() => setShowComingSoonModal(false)}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <GiveUpAccessModal
                show={showGiveUpModal}
                onHide={() => {
                    setShowGiveUpModal(false);
                    setGiveUpRowData(null);
                    setIsRevokeAction(false);
                }}
                rowData={giveUpRowData}
                isRevokeAction={isRevokeAction}
                activeTab={activeTab}
                onSuccess={() => {
                    if (giveUpRowData?.share_id) {
                        // Add the share_id to revokedShareIds
                        setRevokedShareIds(prev => new Set([...prev, giveUpRowData.share_id]));

                        // Remove the row from the appropriate grid based on action type
                        if (isRevokeAction || activeTab === "With You" || activeTab === "By You" || activeTab === "Approve Access") {
                            setSharedReportsData(prev =>
                                prev.filter(row => row.share_id !== giveUpRowData.share_id)
                            );
                        } else {
                            setLstReportsFromOthersComplete(prev =>
                                prev.filter(row => row.share_id !== giveUpRowData.share_id)
                            );
                        }
                    }
                    clearPdfPreview();
                    setShowGiveUpModal(false);
                    setGiveUpRowData(null);
                    setIsRevokeAction(false);
                }}
            />
            <CustomSuccessModal
                show={showRequestModal && requestModalType === 'success'}
                onHide={() => {
                    setShowRequestModal(false);
                    fetchRequestAccessData();
                }}
                message={requestModalMessage}
            />
            <CustomAlertModal
                show={showRequestModal && requestModalType === 'alert'}
                onHide={() => setShowRequestModal(false)}
                message={requestModalMessage}
            />
            <NotificationActionApproveReject
                show={showApprovalModal}
                onHide={(isActionCompleted) => {
                    setShowApprovalModal(false);
                    setApprovalRowData(null);
                    if (isActionCompleted) {
                        // Refresh the Approve Access tab data when action is completed
                        const params = { token, user_id: userId };
                        dispatch(InternalSharedReportsFromOthersComplete(params))
                            .then((response) => {
                                const tableData = response.payload.Table1 || response.payload;
                                if (Array.isArray(tableData)) {
                                    const combinedData = tableData.map((report) => ({
                                        shared_to_user: report.shared_to_user || report.shared_to || '',
                                        sharedBy: report.requested_from_user || report.shared_by_user || report.shared_by || '',
                                        sharedOn: report.shared_on || '',
                                        validUpTo: report.approved_on || '',
                                        shared_from_id: report.shared_from_id || '',
                                        share_id: report.share_id || '',
                                        reportName: report.report_name || '',
                                        approved: report.approved_yn // Keep null/undefined as is for refresh too
                                    }));
                                    setSharedReportsData(combinedData);
                                    setLstReportsFromOthersComplete(combinedData);
                                }
                            })
                            .catch((error) => {
                                console.error("Error refreshing shared reports:", error);
                            });
                    }
                }}
                rowData={approvalRowData}
                onActionComplete={() => {
                }}
            />

            {/* Add Note Dialog */}
            <AddNoteDialog
                show={showNotesDialog}
                onHide={handleNotesClose}
                onSave={handleNotesSave}
                user_id={selectedReportForNotes?.original_user_id || userId}
                report_id={selectedReportForNotes?.report_id}
                token={token}
                reportName={selectedReportForNotes?.report_name}
                isSharedReport={!!selectedReportForNotes?.original_user_id}
            />
        </>
    );
};

export default SharedReports;